// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"383":"6a997c43","777":"f9a3629a"}[chunkId] + ".css";
};